/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


export const renderModelNameString = (version: string) => {
  return (
    version.replaceAll('_', ' ')
  )
}

export const renderVersionString = (version: string) => {
  return (
    version.replaceAll('_', '.')
  )
}
